import { render } from "./TablaPagosBoletos.vue?vue&type=template&id=4b61ea82&scoped=true"
import script from "./TablaPagosBoletos.vue?vue&type=script&lang=js"
export * from "./TablaPagosBoletos.vue?vue&type=script&lang=js"

import "./TablaPagosBoletos.vue?vue&type=style&index=0&id=4b61ea82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b61ea82"]])

export default __exports__